import _regeneratorRuntime from "D:\\new-code\\qingbei-pc\\node_modules\\@babel\\runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: "Complaint",
  data: function data() {
    return {
      type: "",
      type_id: "",
      showModal: false,
      rules: {},
      model: {},
      tags: [],
      tag: "",
      reason: "",
      showOkModal: false
    };
  },
  created: function () {
    var _created = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    function created() {
      return _created.apply(this, arguments);
    }

    return created;
  }(),
  methods: {
    show: function () {
      var _show = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(type, type_id) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (this.$store.state.user_info.id) {
                  _context2.next = 3;
                  break;
                }

                this.$router.push({
                  name: "Login"
                });
                return _context2.abrupt("return");

              case 3:
                this.type = type;
                this.type_id = type_id;
                this.tag = "";
                this.reason = "";
                this.showModal = true;

              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function show(_x, _x2) {
        return _show.apply(this, arguments);
      }

      return show;
    }(),
    confirm: function () {
      var _confirm = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!(this.tag == "")) {
                  _context3.next = 3;
                  break;
                }

                this.$info("请选择举报原因");
                return _context3.abrupt("return");

              case 3:
                _context3.next = 5;
                return this.$http.post("/api/app/complaint", {
                  type: this.type,
                  type_id: this.type_id,
                  tag: this.tag,
                  reason: this.reason
                });

              case 5:
                this.showModal = false;
                this.showOkModal = true;

              case 7:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function confirm() {
        return _confirm.apply(this, arguments);
      }

      return confirm;
    }()
  }
};